var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHourLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 8.3125H7.4375V9.1875H6.5625V8.3125ZM6.5625 10.0625H7.4375V10.9375H6.5625V10.0625Z",
    fill: "#515151"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0625 5.10563V1.75H11.375V0.875H2.625V1.75H3.9375V5.10563C3.9375 5.29495 3.99891 5.47917 4.1125 5.63062L5.14062 7L4.1125 8.36937C3.99891 8.52083 3.9375 8.70505 3.9375 8.89437V12.25H2.625V13.125H11.375V12.25H10.0625V8.89437C10.0625 8.70505 10.0011 8.52083 9.8875 8.36937L8.85938 7L9.8875 5.63062C10.0011 5.47917 10.0625 5.29495 10.0625 5.10563ZM9.1875 1.75V4.8125H4.8125V1.75H9.1875ZM9.1875 8.89437V12.25H4.8125V8.89437L6.23438 7L5.25 5.6875H8.75L7.76562 7L9.1875 8.89437Z",
    fill: "#515151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourLog);
export default __webpack_public_path__ + "static/media/hourLog.84262c11891ba8f4517af73b19ae65ec.svg";
export { ForwardRef as ReactComponent };